import { CloseOutlined } from "@ant-design/icons";
import { cx } from "class-variance-authority";

import { PendoId } from "../../utils/pendo";

import * as theme from "./FilterCountPill.css";

export interface FilterCountPillProps {
    closePendoId?: PendoId;
    label: string;
    closable?: boolean;
    onClose: () => void;
}

export function FilterCountPill({
    label,
    closable = true,
    onClose,
    closePendoId,
}: FilterCountPillProps) {
    return (
        <div className={cx(theme.pill, !closable && theme.pillWithoutClose)}>
            {label}
            {closable && (
                <div
                    role="button"
                    data-pendo={closePendoId}
                    tabIndex={0}
                    className={theme.closeButton}
                    onClick={onClose}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            onClose();
                        }
                    }}
                >
                    <CloseOutlined />
                </div>
            )}
        </div>
    );
}
